import * as React from 'react';
import { memo, useCallback } from 'react';
import NumberFormat from 'react-number-format';

import styled, { css } from 'styled-components';

import { getFontFamily } from 'services/FontService';

export interface IInputPhone extends IInputPhoneStyle {
  value: string;
  placeholder?: string;
  name?: string;
  className?: string;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onEnter?: (value: string) => void;
}

interface IInputPhoneStyle {
  hasError?: boolean;
}

export const InputPhone = memo(
  ({
    value,
    placeholder,
    name,
    className,
    disabled,
    onChange,
    onFocus,
    onBlur,
    onEnter,
    hasError,
  }: IInputPhone) => {
    const onKeyDownHandler = useCallback(
      ({ key }: React.KeyboardEvent<HTMLInputElement>) => {
        if (key === 'Enter') {
          if (onEnter) onEnter(value);
        }
      },
      [value, onEnter],
    );

    return (
      <InputMaskStyled
        value={value}
        format="+############"
        placeholder={placeholder}
        name={name}
        className={`${className} ${hasError && 'hasError'}`}
        disabled={disabled}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDownHandler}
      />
    );
  },
);

const InputMaskStyled = styled(NumberFormat)<{ disabled: boolean }>`
  box-sizing: border-box;
  height: 48px;
  width: 100%;
  border: 1px solid var(--k-border-ebeff2);
  padding: 11px 16px;
  outline: none;
  font-family: ${getFontFamily('regular')};
  font-size: 14px;
  line-height: 24px;
  background-color: var(--k-bg-ffffff);
  cursor: pointer;

  &:focus {
    border-color: var(--k-border-0d53fc);
  }

  &.hasError {
    border-color: var(--k-border-f44336);
  }

  ${({ disabled }) => {
    if (disabled) {
      return css`
        background-color: var(--k-bg-f2f5f9);
        color: var(--k-fg-263446);
        cursor: default;
      `;
    }
  }}
`;
